interface Props {
  stationId: number;
}

export const BaseStationName = ({ stationId }: Props): JSX.Element => {
  return (
    <>#{ stationId }</>
  );
};
